{
	"name": "@cloudillo/prezillo-app",
	"version": "0.8.20",
	"private": true,
	"description": "Prezillo presentations",
	"type": "module",
	"main": "src/index.js",
	"scripts": {
		"l-scan": "i18next-scanner --config src/i18n/scanner.config.cjs",
		"ts": "tsgo --noEmit",
		"ts-watch": "tsgo --noEmit --watch",
		"ts-test": "tsgo --noEmit -p tsconfig.test.json",
		"test": "NODE_OPTIONS=\"--experimental-vm-modules\" jest",
		"test:watch": "NODE_OPTIONS=\"--experimental-vm-modules\" jest --watch",
		"build": "pnpm run ts && cross-env NODE_ENV=production node esbuild.config.js",
		"watch": "node esbuild.config.js --watch",
		"clean": "rimraf .cache dist/assets-*"
	},
	"author": "Szilárd Hajba <szilu@cloudillo.org>",
	"license": "LGPL-3.0-or-later",
	"devDependencies": {
		"@cloudillo/canvas-text": "workspace:^",
		"@cloudillo/canvas-tools": "workspace:^",
		"@cloudillo/core": "workspace:^",
		"@cloudillo/crdt": "workspace:^",
		"@cloudillo/fonts": "workspace:^",
		"@cloudillo/react": "workspace:^",
		"@symbion/opalui": "^0.16.0",
		"@symbion/runtype": "^1.3.1",
		"@types/jest": "^30.0.0",
		"@types/qrcode": "^1.5.6",
		"@types/react": "^19.3.0",
		"@types/react-dom": "^19.3.0",
		"cross-env": "^10.1.0",
		"esbuild": "^0.28.2",
		"fast-xml-parser": "^5.11.2",
		"i18next": "^26.5.2",
		"i18next-scanner": "^4.6.0",
		"i18next-scanner-typescript": "^1.2.1",
		"jest": "^30.5.2",
		"jest-environment-jsdom": "^30.5.2",
		"jotai": "^3.0.1",
		"jspdf": "^4.2.1",
		"jszip": "^3.10.2",
		"pptxgenjs": "^4.0.1",
		"qrcode": "^1.5.4",
		"quill": "^2.0.3",
		"react": "19.3.1",
		"react-dom": "19.3.1",
		"react-i18next": "^17.1.0",
		"react-icons": "^5.7.0",
		"react-qr-code": "^2.2.0",
		"react-router-dom": "^7.18.4",
		"react-svg-canvas": "^0.1.9",
		"react-yjs": "^2.0.1",
		"rimraf": "^6.1.3",
		"svg2pdf.js": "^2.8.1",
		"ts-jest": "^29.4.14",
		"tslib": "^2.8.1",
		"typescript": "npm:@typescript/typescript6@^6.0.2",
		"y-indexeddb": "^9.0.12",
		"y-protocols": "^1.0.7",
		"y-websocket": "^3.1.0",
		"yjs": "^13.6.33"
	}
}
